/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type SbSharedTopTileController_viewer$ref = any;
export type SbSharedTopTileController_viewer = {
    readonly regions?: ReadonlyArray<{
        readonly regionName: string | null;
        readonly urlLabel: string | null;
    } | null> | null;
    readonly " $refType": SbSharedTopTileController_viewer$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "SbSharedTopTileController_viewer",
    "type": "Viewer",
    "metadata": null,
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "isTrade",
            "type": "Boolean"
        }
    ],
    "selections": [
        {
            "kind": "Condition",
            "passingValue": true,
            "condition": "isTrade",
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "regions",
                    "storageKey": "regions(address:{\"country\":\"us\"},regionBoundaryTypes:[\"METROPOLITAN\",\"DISTRICT\",\"DOMESTIC\"],regionType:\"ITEM_LOCATION\")",
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "address",
                            "value": {
                                "country": "us"
                            }
                        },
                        {
                            "kind": "Literal",
                            "name": "regionBoundaryTypes",
                            "value": [
                                "METROPOLITAN",
                                "DISTRICT",
                                "DOMESTIC"
                            ]
                        },
                        {
                            "kind": "Literal",
                            "name": "regionType",
                            "value": "ITEM_LOCATION"
                        }
                    ],
                    "concreteType": "Region",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "regionName",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "urlLabel",
                            "args": null,
                            "storageKey": null
                        }
                    ]
                }
            ]
        }
    ]
} as any);
(node as any).hash = '242993ee437ab43c3face53660f4a30d';
export default node;
